import { render, staticRenderFns } from "./SwitchItem.vue?vue&type=template&id=6c5edf97&scoped=true"
import script from "./SwitchItem.ts?vue&type=script&lang=ts&external"
export * from "./SwitchItem.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5edf97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c5edf97')) {
      api.createRecord('6c5edf97', component.options)
    } else {
      api.reload('6c5edf97', component.options)
    }
    module.hot.accept("./SwitchItem.vue?vue&type=template&id=6c5edf97&scoped=true", function () {
      api.rerender('6c5edf97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Forms/components/SwitchItem/SwitchItem.vue"
export default component.exports